export default {
  createGroup: 'Criar Grupo',
  creatingGroup: 'Criando grupo...',
  newGroup: 'Novo Grupo',
  name: 'Nome',
  required: 'Obrigatório',
  create: 'Criar',
  search: 'Buscar',
  manageGroupUsers: 'Gerenciar usuários do grupo',
  manageGroupModels: 'Gerenciar modelos do grupo',
  manageGroupReferences: 'Gerenciar referências do grupo',
  manageGroupEkrms: 'Gerenciar EKRMs do grupo',
  deleteGroup: 'Excluir grupo',
  warning: 'Aviso',
  deletingGroup: 'Excluindo grupo:',
  cannotBeUndone: 'Esta ação não pode ser desfeita. Tem certeza?',
  cancel: 'Cancelar',
  delete: 'Excluir',
  usersForGroup: 'Usuários do grupo:',
  modelsForGroup: 'Modelos do grupo:',
  referencesForGroup: 'Referências do grupo:',
  ekrmsForGroup: 'EKRMs do grupo:',
  save: 'Salvar',
  abort: 'Abortar',
  confirm: 'Confirmar',
  processing: 'Processando...',
  userHeader: 'Usuário',
  modelHeader: 'Modelo',
  typeHeader: 'Tipo',
  createdHeader: 'Criado',
  referenceHeader: 'Referência',
  ekrmHeader: 'EKRM',
  adHoc: 'Ad-Hoc',
  custom: 'Personalizado',
  nameAlreadyUsed: 'Nome já utilizado'
}
